export default {
  priv: 'pr_device',
  overviewTitle: 'Meettoestellen',
  detailTitle: 'Meettoestel',
  deleteTitle: 'dit toestel',
  url: '/devices/measuredevices',
  apiUrl: '/devices/',
  sortBy: ['desc'],
  sortDesc: [false],
  deletable: true,
  editable: true,
  forEdit: true,
  filterName: 'devicemeasuredevices',
  newRecord: {
    devicecertificatelayout_id_nl: 0,
    devicecertificatelayout_id_fr: 0,
    devicereportlayout_id_nl: 0,
    devicereportlayout_id_fr: 0,
    devicetest_id: 0,
    supplier_address_id: 0,
    devicetype_id: 0,
    is_active: true,
    trafficlight: false
  },
  quickFilter: {
    text: 'Zoeken',
    value: 'misc_search',
    type: 'text'
  },
  advancedSearchFields: [
    {
      text: 'Zoek tekst',
      value: 'misc_search',
      type: 'text'
    },
    {
      text: 'Type',
      value: 'devicetype_id',
      type: 'optionList',
      optionListName: 'devicetypes',
      optionListDynamicParams: { devicegroup_id: 'this.getDeviceGroupID()' }
    },
    {
      text: 'Toezichter',
      value: 'supervisor_id',
      type: 'optionList',
      optionListName: 'supervisors'
    }
  ],
  tableFields: [
    {
      text: 'Omschrijving',
      value: 'desc',
      link: '/devices/measuredevices/{id}',
      width: '25%'
    },
    {
      text: 'Serienummer',
      value: 'serial_nr',
      width: '25%'
    },
    {
      text: 'Type',
      value: 'devicetype',
      width: '20%'
    },
    {
      text: 'Bouwjaar',
      value: 'construction_year',
      width: '20%'
    }
  ]
};
